import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { RichText as RichTextConverter } from '@payloadcms/richtext-lexical/react';

type Props = {
    data: SerializedEditorState;
} & React.HTMLAttributes<HTMLDivElement>;

export function RichText({ data, className, ...rest }: Props) {
    const isValidRichText =
        typeof data === 'object' &&
        data !== null &&
        'root' in data &&
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        typeof (data as any).root === 'object';

    if (!isValidRichText) return null;

    return (
        <RichTextConverter
            {...rest}
            className={className}
            converters={jsxConverter}
            data={data as SerializedEditorState}
        />
    );
}

import { SerializedHeadingNode } from '@payloadcms/richtext-lexical';
import { JSXConverters } from '@payloadcms/richtext-lexical/react';

export const headingConverter: JSXConverters<SerializedHeadingNode> = {
    heading: ({ node, nodesToJSX }) => {
        if (node.tag === 'h2') {
            const text = nodesToJSX({ nodes: node.children });

            const id = text
                .join('')
                .toLowerCase()
                .replace(/\s+/g, '-')
                .replace(/[^a-z0-9-]/g, '');
            return <h2 id={id}>{text}</h2>;
        } else {
            const text = nodesToJSX({ nodes: node.children }).join('');
            const Tag = node.tag;
            return <Tag>{text}</Tag>;
        }
    },
};

import { DefaultNodeTypes } from '@payloadcms/richtext-lexical';
import { JSXConvertersFunction } from '@payloadcms/richtext-lexical/react';

type NodeTypes = DefaultNodeTypes;

export const jsxConverter: JSXConvertersFunction<NodeTypes> = ({
    defaultConverters,
}) => ({
    ...defaultConverters,
    ...headingConverter,
});
